import DataTable from 'src/components/dataTable';
import {useDeleteIntegration} from './mutations';
import {Integration} from 'src/core/data/api/Integration';
import {ViewType} from './container';
import useAlerts from 'src/hooks/use-alerts';
import {useIntl} from 'react-intl';

interface IntegrationListViewProps {
    integrations: Integration[];
    loading: boolean;
    onViewChange: (viewType: ViewType, integration?: Integration) => void;
}

const IntegrationListView = ({integrations, loading, onViewChange}: IntegrationListViewProps) => {
    const intl = useIntl();
    const {toast} = useAlerts();
    const {mutate: deleteIntegration} = useDeleteIntegration();

    const onAdd = () => {
        onViewChange('create');
    };

    const onEdit = (selectedIntegration: Integration) => {
        onViewChange('edit', selectedIntegration);
    };

    const onApiError = (error: any) => {
        toast.errorStatus(error);
    };

    const onRemoveSuccess = () => {
        toast.success(intl.formatMessage({id: 'sharedRemovedSuccess'}));
        onViewChange('list');
    };

    const handleRemove = (selectedIntegration: Integration) => {
        deleteIntegration(selectedIntegration.id, {
            onSuccess: onRemoveSuccess,
            onError: onApiError,
        });
    };

    return (
        <DataTable
            add={onAdd}
            edit={onEdit}
            remove={handleRemove}
            list={integrations}
            loading={loading}
            attributes={undefined}
            keyField={'id'}
            confirmText={intl.formatMessage({id: 'integrationRemoveConfirm'})}
            headers={[
                {title: 'sharedName', field: 'title', dataSort: true},
                {title: 'sharedDescription', field: 'description', dataSort: false},
            ]}
        />
    );
};

export default IntegrationListView;
